module.exports = __webpack_public_path__ + "static/media/organizer_16.474849de.jpg";